import { Collection, CollectionStateful } from '@redge-media/fo-js-sdk';

const ChannelsCollection = Collection.extend(CollectionStateful, {});

export default ChannelsCollection;
